import _isNil from "lodash/isNil";
import _includes from "lodash/includes";
import _get from "lodash/get";
import _findLast from "lodash/findLast";
/* eslint-disable @typescript-eslint/no-explicit-any */
const TYPE_HTML_LINK = 'html_link';
const SUPPORTED_TYPES = [TYPE_HTML_LINK];
const ERROR_TYPES = ['backend-error', 'error'];
const getUrlFromOutputs = (results, multiplexerUrl) => {
  const result = _findLast(results, _ref => {
    let {
      type
    } = _ref;
    return _includes(SUPPORTED_TYPES, type);
  });
  const error = _findLast(results, _ref2 => {
    let {
      type
    } = _ref2;
    return _includes(ERROR_TYPES, type);
  });
  if (!_isNil(error)) {
    throw new Error("Backend Error: ".concat(error.payload));
  }
  if (_isNil(result)) {
    return null;
  }
  const isRelativeToMultiplexer = _get(result, 'payload_details.is_relative_to_multiplexer', false);
  return "".concat(isRelativeToMultiplexer ? multiplexerUrl : '').concat(result.payload);
};
export default getUrlFromOutputs;